import React from 'react';

import { Container } from './styles';

const Table = ({ children }) => {
  return <Container>{children}</Container>;
}

export default Table;
